import { getFileUri } from '../../../HttpRequests/modelFiles'
import handleException from '../../../Core/Helpers/handleException'

export default () => async (dispatch, getState) => {

  const { selectedItemPath } = getState().modules.FileManager

  const params = {
    path: selectedItemPath,
  }

  try {

    const response = await getFileUri({ params })

    window.open(response.data)

  } catch (error) {

    handleException(error)

  }

}
